import { Box, Grid } from "@mui/material";

import PosterCard from "./PosterCard";
import BeefMerchandisingCard from "./BeefMerchandisingCard";
import { languages } from "../../utils/translate";

const PosterContainer = ({ language = languages[0] }) => {
  return (
    <Box sx={{ pt: 4 }}>
      <Box sx={{ flexGrow: 1, my: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4} lg={4}>
            <PosterCard />
          </Grid>
          <Grid item xs={6} md={4} lg={4}>
            <BeefMerchandisingCard language={language} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PosterContainer;
